// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckboxField_wrapper__6p5px","hidden":"CheckboxField_hidden__Elzf_","label":"CheckboxField_label__zw8df","error":"CheckboxField_error__FA1Sr"};